export function getTopLevelCustomer() {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        registeredBusinessName: "ABC Company TLDR",
        countryOfRegistration: "Unated States of America",
        taxId: "123-123-123",
        registeredAddress: {
          streetAddress1: "2957 Marcus Street",
          streetAddress2: "Huntsville",
          city: "New York City",
          state: "New York",
          postcode: "123 342",
          country: "Alabama",
        },
      });
    }, 500);
  });
}

export function postCustomerLogo(id, { logoType, file }) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({});
    }, 2000);
  });
}

export function deleteCustomerLogo(id, { logoType }) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({});
    }, 2000);
  });
}
